import axios from "axios";
import { ADMINAPI_BASE_URL } from "./base_urls"

const singleton = Symbol();
const singletonEnforcer = Symbol();

class ApiInterface {
  constructor(enforcer) {
    if (enforcer !== singletonEnforcer) {
      throw new Error("Cannot construct singleton");
    }

    this.session = axios.create({
      baseURL: `${ADMINAPI_BASE_URL}/api`,
      headers: {
        Accept: "application/json",
        'Authorization': `Bearer ${localStorage.getItem("auth0_token")}`
      },
    });

    this.session.defaults.validateStatus = (status) => status >= 200 && status < 300;
    this.session.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    this.session.interceptors.request.use((request) => {
      return request;
    });
  }

  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new ApiInterface(singletonEnforcer);
    }

    return this[singleton];
  }

  static reInstance() {
    this[singleton] = new ApiInterface(singletonEnforcer);
  }

  get = (...params) => this.session.get(...params);
  post = (...params) => this.session.post(...params);
  put = (...params) => this.session.put(...params);
  patch = (...params) => this.session.patch(...params);
  remove = (...params) => this.session.delete(...params);

  updatePassword = (data) => this.session.post("/updatePassword/", data);
  sendResetLinkEmail = (data) => this.session.post("/reset/password/", data);
  resetPassword = (data) => this.session.post("/reset/confirmreset/", data);
  verifyEmail = (link) => this.session.post(link);
  resendVerificationEmail = () => this.session.post("/email/resend");

  me = () => this.session.get("/me/");
  userProfile = () => this.session.get('https://fastmap.us.auth0.com/userinfo')
  updateProfile = (data) => this.session.put(`/me/update/`, data);
  deleteProfile = () => this.session.post(`/me/delete/`);

  createTeam = (data) => this.session.post("/organizations_team/create_team/", data);
  getTeam = (id) => this.session.get(`/organizations_team/get_team_stats/?org=${id}`);
  getUserTeamMembers = (id) => this.session.get(`/organizations_team/get_user_team_members/`);
  addUserGuestToTeam = (org_id, email, role, team_id) => this.session.get(`/organizations_user/invite/?org=${org_id}&email=${email}&role=${role}&team=${team_id}`);
  getRoles = () => this.session.get("/organizations_user/roles-list/");
  getUserData = (id) => this.session.get(`/organizations_user/user_list/?org=${id}`);
  getGuestData = (id) => this.session.get(`/organizations_user/guest_list/?org=${id}`);
  deleteTeams = (data) => this.session.post(`/organizations_team/delete/`, data);
  deleteGuestsUsers = (data) => this.session.post("/organizations_user/delete/", data);
  invitation = (data) => this.session.post("/handle_invite/", data);
  updateTeam = (id, data) => this.session.patch(`/organizations_user/update_team/`, data);
  updateRole = (id, data) => this.session.post(`/organizations_user/set_user_role/${id}/`, data);
  updateOrganization = (id, data) => this.session.patch(`/organizations/update_organization/?org=${id}`, data);
}
export default ApiInterface;
